import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { connectCustom } from "@client/lib/misc";
import { type AppState, type EntityRef } from "@client/types";
import Component, { type MapProps } from "./component";

type Props = EntityRef & {
  cycleEndDate: string;
  incentiveId: string;

  onBackClick: () => void;
};
const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();

  return (state: AppState, props: Props): MapProps => {
    return {
      ...props,
      apiInfo: apiInfoSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
